<template>
  <div class="rewards-payout">
    <button
      class="rewards-payout__button"
      :class="rewardsPayoutButtonClass"
      @click="handleButtonClick"
    >
      {{ total }} ₽
      <Icon name="chevron" :size="16" />
    </button>
    <div
      class="rewards-payout__details"
      :class="rewardsPayoutDetailsClass"
    >
      <p>{{ $t('rewards.payoutDetailsTotal') }}: {{ total }} ₽</p>
      <p>{{ $t('rewards.payoutDetailsComission') }}: {{ commission }} ₽</p>
      <p>{{ $t('rewards.payoutDetailsPayout') }}: {{ payout }} ₽</p>
    </div>
  </div>
</template>

<script>
import Icon from '@components/v2/utils/Icon.vue';

export default {
  name: 'RewardsPayout',

  components: {
    Icon
  },

  props: {
    payout: {
      type: String,
      default: '',
    },
    commission: {
      type: String,
      default: '',
    },
    total: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isOpened: false,
    };
  },

  computed: {
    rewardsPayoutButtonClass() {
      return this.isOpened
        ? 'rewards-payout__button--opened'
        : 'rewards-payout__button--closed'
    },
    rewardsPayoutDetailsClass() {
      return this.isOpened
        ? 'rewards-payout__details--opened'
        : 'rewards-payout__details--closed'
    },
  },

  methods: {
    handleButtonClick() {
      this.isOpened = !this.isOpened
    }
  },
};
</script>

<style lang="scss" scoped>
.rewards-payout {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  position: relative;
}
.rewards-payout__button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #f5f5f7;
  background: none;
  border: none;

  &--opened {
    svg {
      transform: rotate(180deg);
    }
  }
  &--closed {
    svg {
      transform: rotate(0deg);
    }
  }
}
.rewards-payout__details {
  width: 100%;
  padding: 0 8px;
  border-radius: 8px;
  text-align: left;
  background: #2d2d30;
  color: #979797;
  z-index: 0;
  overflow: hidden;
  transition: 0.2s ease-in-out;
  transition-property: max-height, padding;

  &--opened {
    max-height: 100px;
    padding: 8px 8px;
  }
  &--closed {
    max-height: 0;
    padding: 0 8px;
  }
}
</style>
